import * as types from "../type/User.type";

const initialState = (() => ({
  disable: false,
  ignore: false,
  forgetDisable: false,
  loginFn: () => {}
}))();

const User = (state = { ...initialState }, { type, res }) => {
  switch (type) {
    case types.RESET:
      return {
        ...state,
        disable: res
      };
    case types.LOGIN:
      return {
        ...state,
        ...res
      };
    case types.SIGN_OUT:
      return {
        ...state,
        ...res
      };
    case types.IGNORE:
      return {
        ...state,
        ...res
      };
    case types.IS_DISABLE:
      return {
        ...state,
        ...res
      };
    case types.IS_FORGET_DISABLE:
      return {
        ...state,
        ...res
      };
    case types.RESET_FORGET_DISABLE:
      return {
        ...state,
        forgetDisable: res
      };
    case types.LOGIN_ACTION:
      return {
        ...state,
        loginAction: res
      };
    case types.LOGIN_ACTION_HIDE:
      return {
        ...state,
        loginAction: res
      };
    case types.LOGIN_FN:
      return {
        ...state,
        loginFn: res
      };
    default:
      return state;
  }
};
export default User;



// WEBPACK FOOTER //
// ./src/redux/reducer/User.reducer.js